import classNames from 'classnames';
import React from 'react';

import * as styles from './marquee.module.css';

interface MarqueeHeaderProps {
	dynamicContent?: string;
	headerText?: string;
	useDynamicContent?: boolean;
	headerTextOverride?: string;
}

export const MarqueeHeader: React.FC<MarqueeHeaderProps> = ({
	dynamicContent,
	headerText,
	headerTextOverride,
	useDynamicContent,
}) => {
	return (
		headerText && (
			<p className={classNames('body-sm-caps', styles.headerCopy)}>
				{useDynamicContent && dynamicContent
					? dynamicContent
					: headerTextOverride ?? headerText}
			</p>
		)
	);
};
